import { DATE_PIPE_DEFAULT_OPTIONS, DOCUMENT, registerLocaleData } from '@angular/common';
import { Injectable, InjectionToken, LOCALE_ID, NgModule, Optional, SkipSelf, inject, } from '@angular/core';
import { LuxonDateAdapter, MatLuxonDateModule } from '@angular/material-luxon-adapter';
import { DateAdapter, MAT_DATE_LOCALE } from '@angular/material/core';
import { IconsModule } from 'app/core/icons/icons.module';
import { LocalStorageService } from 'app/services/local-storage.service';
import { S_LOCALE } from 'app/services/selected-locale.service';
import { MAT_SELECTSEARCH_DEFAULT_OPTIONS, MatSelectSearchOptions } from 'ngx-mat-select-search';
import { TimeAdapter, NativeDateTimeAdapter } from '@dhutaryan/ngx-mat-timepicker';
import { NgcCookieConsentConfig, NgcCookieConsentModule } from 'ngx-cookieconsent';

const cookieConfig: NgcCookieConsentConfig = {
  "enabled": false,
  "cookie": {
    "domain": "https://app.timelake.io/"
  },
  "position": "bottom-right",
  "theme": "block",
  "palette": {
    "popup": {
      "background": "#131D35",
      "text": "#ffffff",
      "link": "#ffffff"
    },
    "button": {
      "background": "#4F46E5",
      "text": "#fff",
      "border": "transparent"
    }
  },
  "type": "info",
  "content": {
    "message": "We use cookies to ensure you get the best experience on our web application.",
    "dismiss": "Accept",
    "link": "More information",
    "href": "https://docs.timelake.io/legal/privacy-policy#id-3.-cookies",
    "policy": "Cookie Policy"
  }
};

// import localeRu from '@angular/common/locales/ru';
// import localeRuExtra from '@angular/common/locales/extra/ru';
// registerLocaleData(localeRu, 'ru-RU', localeRuExtra);

export const WINDOW = new InjectionToken<Window>(
  'An abstraction over global window object',
  {
    factory: () => inject(DOCUMENT).defaultView!
  },
);

export const NAVIGATOR = new InjectionToken<Navigator>(
  'An abstraction over window.navigator object',
  {
    factory: () => inject(WINDOW).navigator,
  },
);
@Injectable()
export class CustomDateAdapter extends LuxonDateAdapter {
  override getFirstDayOfWeek(): number {
    return 1;
  }
}
@NgModule({
  imports: [
    IconsModule,
    MatLuxonDateModule,
    NgcCookieConsentModule.forRoot(cookieConfig),
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    {
      provide: TimeAdapter, useClass: NativeDateTimeAdapter
    },
    {
      provide: MAT_DATE_LOCALE,
      useFactory: (navigator, sLocaleService, localStorageService) => {
        const sLocale = sLocaleService;
        const locale = sLocale || navigator?.language || 'en-GB';
        localStorageService.setItem('locale', locale);
        return locale;
      },
      deps: [NAVIGATOR, S_LOCALE, LocalStorageService]
    },
    { provide: LOCALE_ID, useValue: 'en-GB' },

    // { provide: MAT_DATE_FORMATS, useValue: MAT_LUXON_DATE_FORMATS },
    {
      provide: DATE_PIPE_DEFAULT_OPTIONS,
      useFactory: () => {
        return { dateFormat: 'mediumDate' }
      }
    },
    {
      provide: MAT_SELECTSEARCH_DEFAULT_OPTIONS,
      useValue: <MatSelectSearchOptions>{
        closeIcon: 'close',
        recreateValuesArray: false
        // clearSearchInput: true,

      }
    }
  ]
})
export class CoreModule {
  /**
   * Constructor
   */
  constructor(
    @Optional() @SkipSelf() parentModule?: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule has already been loaded. Import this module in the AppModule only.');
    }
  }
}
